module.exports = __webpack_public_path__ + "img/icon_log.ab9d12d1.png";